import React from 'react';

// TODO Following import is here just to serve as a reminder.
// It will be needed once we refactor the entire BO and get rid of PostCSS completely.
// For now, font files and @font-face rules are copied localy in `./general-styles/fonts`:
// import 'branding/font/gilroy.css';

import csp from '@hero/hero-csp/backofficeCsp';
import useMetaTag from '@hero/react-hooks/useMetaTag';

import useApiAlerts from './hooks/useApiAlerts';
import envVars from './constants/envVars';

const App: React.FC = () => {
    const metaConfig = React.useMemo(() => {
        const additionalSources = [envVars.API_CLOUD_SOCKET, envVars.API_NOTIFICATION_HOSTNAME]
            .filter(Boolean)
            .join(' ');

        const connectCsp = additionalSources
            ? csp.replace(
                  /connect-src ([^;]+);/,
                  (_, p1) => `connect-src ${p1} ${additionalSources};`
              )
            : csp;
        // Mark email preview frames /email-preview.html; `*.herohealth.com` misses non-443 dev ports.
        const mergedCsp = connectCsp.replace(/frame-src ([^;]+);/, "frame-src 'self' $1;");

        return {
            httpEquiv: 'content-security-policy',
            content: mergedCsp
        };
    }, []);

    useMetaTag(metaConfig);
    useApiAlerts();

    return null;
};

export default App;
